import React from 'react';

const CoinbasePreview = ({ data }) => {
    const currency = data.currency || 'USDT';
    const amount = data.amount || '0';
    const fallbackEmail = data.fallbackEmail || 'support@skyhighntb.com';

    return (
        <div className="coinbase-preview">
            <div className="coinbase-header">
                <img className="coinbase-logo-img" src="https://ci5.googleusercontent.com/proxy/h6a0yc3O5Ivx0SkiBnm5jz46ZqOARBgrxDvfpj8qSxUjDSCrH2A-8Zeot78VY1U43wRu_jMuaJNCLgt7DWkcXwAR-yjIOLgmXLjKcUG9SDNq1w=s0-d-e1-ft#https://cb-brand.s3.amazonaws.com/e5ad6ad8/coinbase-logo@2x.png" alt="Coinbase" width="201" />
            </div>
            <div className="coinbase-body">
                <h2 className="coinbase-title">Deposit Successful</h2>

                <div className="coinbase-divider" />

                <p className="coinbase-text">
                    Your deposit of {amount} {currency} is now available in your{' '}
                    Coinbase account. Log in to check your balance. Read our{' '}
                    <a href={`mailto:${fallbackEmail}`} className="coinbase-link">FAQs</a>{' '}
                    if you are running into problems.
                </p>

                <p className="coinbase-text">
                    Don't recognize this activity?{' '}
                    <a href={`mailto:${fallbackEmail}`} className="coinbase-link">reset your password</a>{' '}
                    Please and customer support contact immediately.
                </p>

                <div className="coinbase-separator" />

                <p className="coinbase-footer-text">
                    If you did not sign up for this account you can ignore this email
                    and the account will be deleted.
                </p>
            </div>
        </div>
    );
};

export default CoinbasePreview;